import { ITavusPersonaFormik } from 'entities/tavus/persona';
import { FormikProps } from 'formik';
import { Switch } from 'shared/ui';

interface ITavusRecord {
  formik: FormikProps<ITavusPersonaFormik>;
}

const TavusRecord = ({ formik }: ITavusRecord) => {
  return (
    <div className="ag-h-full ag-overflow-y-auto ag-flex ag-flex-col ag-gap-y-4">
      <div className="ag-flex ag-items-center ag-justify-between">
        <span className="ag-text-neutral-700 ag-font-medium">Recording</span>
        <Switch
          onChange={(value) => formik.setFieldValue('isRecording', value)}
          checked={formik.values.isRecording}
        />
      </div>
    </div>
  );
};

export default TavusRecord;
